<div class="dx-card wide-card">
  <h4 class="content-block ap-green">Industry Code Mapping (SIC/NAICS/NACE)</h4>
  <dx-data-grid *ngIf="isApIndustryCodesLoaded && isGlobalIndustryCodesLoaded" class="fixGridHeight"
    id="IndustryCodesGrid" [dataSource]="mappedindustrycodes" (onRowUpdated)="addMappings($event)" [showRowLines]="true"
    [showColumnLines]="true" (onEditorPreparing)="onEditorPreparing($event)" [showBorders]="true"
    [allowColumnResizing]="true" [rowAlternationEnabled]="true">
    <dxo-filter-row [visible]="true"></dxo-filter-row>
    <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
    <dxo-header-filter [visible]="true"></dxo-header-filter>
    <dxo-sorting mode="multiple"></dxo-sorting>
    <dxo-search-panel [visible]="true"></dxo-search-panel>
    <dxo-export [enabled]="false"></dxo-export>
    <dxo-editing mode="row" [useIcons]="true" [allowUpdating]="true" [allowAdding]="false" mode="row">
    </dxo-editing>
    <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
    <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
    <dxo-toolbar>
      <dxi-item name="groupPanel"></dxi-item>
      <dxi-item location="after">
        <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()">
        </dx-button>
        <dx-button icon="exportxlsx" stylingMode="contained" type="default" text="Export to Excel" (onClick)="exportExcel($event)">
        </dx-button>
      </dxi-item>
      <dxi-item name="searchPanel"></dxi-item>
    </dxo-toolbar>
    <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true" [showInfo]="true"
      [showNavigationButtons]="false"></dxo-pager>
    <dxi-column type="buttons" [width]="80">
      <dxi-button name="edit"></dxi-button>
    </dxi-column>
    <dxi-column dataField="industryCodeType" [allowEditing]="false" [width]="150"></dxi-column>
    <dxi-column dataField="industryCode" [allowEditing]="false" dataType="string" [width]="150"></dxi-column>
    <dxi-column dataField="industryCodeDescription" [allowEditing]="false" [width]="350"></dxi-column>
    <dxi-column dataField="majorSegmentAPIndustrySegmentID" [sortIndex]="1" sortOrder="asc"
      [setCellValue]="setmajorSegmentAPIndustrySegmentValue" caption="Major Segment - AP Industry" [minWidth]="550">
      <dxo-lookup [dataSource]="apindustrycodes" displayExpr="majorSegmentAPIndustrySegment"
        valueExpr="majorSegmentAPIndustrySegmentID">
      </dxo-lookup>
    </dxi-column>
    <dxi-column dataField="globalIndustrySegmentId" [width]="300" [setCellValue]="setGlobalIndustrySegmentValue"
      caption="Global Industry Segment">
      <dxo-lookup [dataSource]="gindustrycodes" displayExpr="name" valueExpr="globalIndustrySegmentId">
      </dxo-lookup>
    </dxi-column>
  </dx-data-grid>

  <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
    [shading]="false" [closeOnOutsideClick]="false">
  </dx-load-panel>
</div>